module.exports = __webpack_public_path__ + "static/media/tyre-red-four1.7946bcd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-four1.png
// module id = 335
// module chunks = 0